// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"6d8ed067","80":"e147a2cd","260":"247e20cf","398":"15241b9a","428":"df86e0d0","433":"b1acf239","538":"ba8d5c98","662":"040609d6","694":"69a3564b","751":"130693c5","774":"9bc6a0c0","787":"28cb0dcd","985":"6576a97a"}[chunkId] + ".chunk.js";
};